jQuery(document).ready(function($) {
	const loaderHtml = `<div class="merchup-loader blockUI blockOverlay"></div>`;
	let ajaxInProgress = false;

	const $form = $('.m-newsletter-content-form');
	$form.submit(function(event) {
		const $this = $(this);
		$this.append(loaderHtml);

		if (ajaxInProgress) {
			event.preventDefault();
			return;
		}

		ajaxInProgress = true;

		$.ajax({
			url: merchupSettings.ajaxUrl,
			type: 'POST',
			data: $this.serialize(),
		})
		.done(function(response) {
			if (response.success) {
				const data = response.data;

				let $response = $this.find('.m-newsletter-content-form-row--response');
				$response.remove();

				const responseHTML = `
					<p class="m-newsletter-content-form-row m-newsletter-content-form-row--response" hidden>
						${data.text}
					</p>
				`;

				const $checkboxRow = $form.find('.m-newsletter-content-form-row--checkbox');
				$checkboxRow.after(responseHTML);
				$form[0].reset();

				$response = $this.find('.m-newsletter-content-form-row--response');
				$response.slideDown();
			}
		})
		.always(function() {
			const $loader = $form.find('.merchup-loader');
			$loader.fadeOut(300, function() {
				$loader.remove();
			});

			ajaxInProgress = false;
		});

		event.preventDefault();
	});
});
